import { initializeGTM } from './google_tag_manager';
import { initSentry } from './sentry';
import { scheduleBootstrap } from './utils/session_bootstrap';
import '@hotwired/turbo-rails';
import './controllers/pflegeplatz_controllers';

// Initialize Sentry
initSentry();
scheduleBootstrap();

window.addEventListener('load', () => {
    initializeGTM();
});
